function mapQuestionRecursively(question, sectionResponses) {
  const baseAnswer = sectionResponses[question.name] ?? null;

  // Leaf node
  if (!question.sub_questions || question.sub_questions.length === 0) {
    return {
      name: question.name,
      question: question.question,
      answer: baseAnswer,
      nestedQuestion: null,
    };
  }

  // Recursive mapping (same sectionResponses passed down)
  const nested = question.sub_questions.map((subQ) => mapQuestionRecursively(subQ, sectionResponses));

  return {
    name: question.name,
    question: question.question,
    answer: baseAnswer,
    nestedQuestion: nested,
  };
}

export function questionAnswerMapper(questionBankObj, responses) {
  const finalOutput = [];

  for (const section in questionBankObj) {
    const questions = questionBankObj[section];
    if (!Array.isArray(questions)) continue;

    //  IMPORTANT: Pick only THIS SECTION's responses
    const sectionResponses = responses[section] || {};

    const mappedQuestions = questions.map((question) => mapQuestionRecursively(question, sectionResponses));

    finalOutput.push({
      section,
      questions: mappedQuestions,
    });
  }

  return finalOutput;
}
